<!--在线客服-->
<template>
  <div class="service-container">
    <headerIndex/>
    <div class="service-header" :style="'min-height:'+min_height+'px;'">
      <el-container class="service-content">
        <el-aside style="width:350px;min-height: 85vh;" class="el-aside-user-thing">
          <div class="user-menu">
            <div class="user-top">
              <el-avatar :src="CustomInfo.useravatar" :size="48" shape="square"/>
              <div class="online-user-name">
                <p class="user-name">{{ CustomInfo.userID }}</p>
                <p class="blurb">{{ CustomInfo.introduction }}</p>
              </div>
            </div>
            <el-input placeholder="搜索最近联系人" prefix-icon="el-icon-search" v-model="keyword"/>
          </div>
          <div class="search-content" :style="'display:'+displayNo">
            <div v-for="user of searchUserInfo" class="user-list" @click="nowOnLine(user)">
              <el-avatar :src="user.tavatar" :size="32" shape="square" fit="cover"/>
              <span class="user-name">{{ user.toName }}</span>
            </div>
          </div>
          <div class="el-user-list">
            <div v-for="line of chatUserInfo" :class="online_id!=line.roomId ? 'user-list' : 'online-user'"
                 @click="nowOnLine(line)">
              <el-badge :value="line.newMsgTotal>99 ? '99+' : line.newMsgTotal" class="item" v-if="line.newMsgTotal>0">
                <el-avatar :src="line.tavatar" :size="32" shape="square" fit="cover"/>
              </el-badge>
              <el-avatar :src="line.tavatar" :size="32" shape="square" fit="cover" v-else/>
              <span class="user-name">{{ line.toName }}</span>
            </div>
          </div>
        </el-aside>
        <el-container>
          <el-header class="el-header-online-user" height="75">
            <el-avatar :src="onLineUserInfo.tavatar" :size="48" shape="square"/>
            <span class="online-user-name">{{ onLineUserInfo.toName }}</span>
          </el-header>
          <el-main style="max-height: 51vh" class="el-main-content" id="box1" ref="messageBox">
            <div ref="messageMove" id="messageMove">
              <div style="display: flex;justify-content: center;">
                <vxe-button type="text" content="点击加载更多" :loading="isLoading" @click="getMoreMessage"/>
              </div>
              <div v-for="doc of docInfo">
                <p class="service-time" v-if="doc.ishsow">{{ timeFormat(doc.time - 0) }}</p>
                <div v-if="doc.userId!=CustomInfo.cid" class="service-content-list-left">
                  <el-avatar :src="doc.userAvatar" :size="32" shape="square"/>
                  <div style="margin-left: 15px">
                    <p class="service-name">{{ doc.userName }}</p>
                    <div class="service-info" v-html="doc.text" v-if="doc.type=='TEXT'"/>
                    <div class="service-image" v-else @click="seePdf(doc.text)">
                      <el-image :src="doc.text" style="border-radius: 0px 12px 12px 12px"/>
                    </div>
                  </div>
                </div>
                <div v-else class="service-content-list-right">
                  <div style="margin-right: 15px;text-align: right;">
                    <p class="service-name">{{ doc.userName }}</p>
                    <div class="service-info" v-html="doc.text" v-if="doc.type=='TEXT'"/>
                    <div class="service-image" v-else @click="seePdf(doc.text)">
                      <el-image :src="doc.text" style="border-radius: 12px 0px 12px 12px"/>
                    </div>
                  </div>
                  <el-avatar :src="doc.userAvatar" :size="32" shape="square"/>
                </div>
              </div>
            </div>
          </el-main>
          <el-footer style="border:1px solid #EEEEEE">
            <div class="footer-toolbar">
              <el-popover placement="top-start" width="400" v-model="toggleEmoji">
                <div class="emojiList">
                  <span v-for="row in emoji" :key="row" @click="addEmoji(row)">{{ row }}</span>
                </div>
                <div class="mask" @click="toggleEmoji = false"/>
                <i class="iconfont icon-emoji" slot="reference" style="color: #666666"/>
              </el-popover>
              <el-upload action="http://bqwapi.bangqichat.com/home/rest/uploadImgForWangsuyun/uploadImg"
                         ref="upload" list-type="picture-card" :file-list="fileList" :multiple="true"
                         :on-success="successUpload" accept=".png,.jpeg,.jpg,.pdf">
                <i class="iconfont icon-upload-image" style="font-size: inherit;margin-left: 10px;color: #666666;"/>
              </el-upload>
            </div>
            <el-input type="textarea" placeholder="" v-model="sendThing" maxlength="3000"
                      :autosize="{ minRows: 6,maxRows:6}"/>
            <el-button class="el-send" @click="send">发送</el-button>
          </el-footer>
        </el-container>
      </el-container>
    </div>
    <home_footer/>
    <Hang/>
    <el-dialog :visible.sync="dialogImage" title="图片预览" width="550px" top="0px">
      <el-image :src="dialogImageUrl" style="width: 500px;height: auto"/>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue';
import headerIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import emoji from "@/common/emoji";
import websocket from "@/common/WebSocket";
import {joinShop} from "@/api/cloudServiceApi";
import {
  privateLetter,
  msgCurrentRoomList,
  msgChatLog,
  makeOfflineMessagesRead,
  msgFriendSearch
} from '@/api/messageApi'
import store from "@/store";
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import {getCustomInfo} from '@/api/systemSetting'
Vue.use(VXETable)
export default {
  name: "index",
  components: {Hang, Home_footer, headerIndex},
  data() {
    return {
      min_height: document.documentElement.clientHeight - 275,
      CustomInfo: {},
      keyword: '',
      online_id: '',
      emoji,
      showEmoji: 'none',
      toggleEmoji: false,
      sendThing: '',
      id: 0,
      bqwShop: {},
      roomId: 0,
      onLineUserInfo: {},
      page: 1,
      isLoading:false,
      isMove:true,
      dialogImageUrl:'',
      dialogImage:false,
      fileList:[],
      searchUserInfo:[],
      displayNo:'none',
    }
  },
  computed: {
    docInfo() {
      return store.state.chatRecord.chatProject;
    },
    chatUserInfo() {
      return store.state.chatUserInfo;
    },
  },
  watch: {
    keyword: function (val, oldVal) {
      this.searchUser();
    }
  },
  methods: {
    timeFormat(timestamp) {
      let time = new Date(timestamp);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let hours = time.getHours();
      let minutes = time.getMinutes();
      let seconds = time.getSeconds();
      return year + '-' + this.addZero(month) + '-' + this.addZero(date) + ' ' + this.addZero(hours) + ':' + this.addZero(minutes) + ':' + this.addZero(seconds)
    },
    addZero(num) {
      return num < 10 ? '0' + num : num
    },
    nowOnLine(row) {
      let that = this;
      that.searchUserInfo=[];
      that.displayNo='none';
      this.chatUserInfo.forEach(function (item) {
        if (item.roomId == row.roomId) {
          that.makeOfflineRead(item.roomId);
          item.newMsgTotal = 0;
          item.newMsg = false;
          that.online_id = item.roomId;
          that.onLineUserInfo = item;
          that.page = 1;
          store.state.chatRecord = item;
          store.state.chatRecord.chatProject = [];
          that.isLoading=true;
          window.isMove=true;
          that.getChatLog();
        }
      })
    },
    /*设置消息为已读*/
    makeOfflineRead(roomId,) {
      makeOfflineMessagesRead({
        roomId: roomId,
        tuid: this.CustomInfo.cid != 0 && this.CustomInfo.cid != undefined ? this.CustomInfo.cid : 0
      }).then(res => {
      })
    },
    //在文章后面添加emoji表情
    addEmoji(emoji) {
      setTimeout(() => {
        this.sendThing = this.sendThing + emoji;
        this.toggleEmoji = false;
      }, 100);
    },
    // 计算时间差
    dateDiff(endTime, startTime) {
      let dateBegin = new Date(startTime);
      let dateEnd = new Date(endTime);
      let dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
      let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
      let leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      let hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
      //计算相差分钟数
      let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
      //计算相差秒数
      let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      let seconds = Math.round(leave3 / 1000);
      console.log("相差" + dayDiff + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒");
      return minutes;
    },
    /*发送消息*/
    send() {
      let time = new Date().getTime();
      websocket.Send(5, this.onLineUserInfo.tuid.toString(), this.sendThing, this.onLineUserInfo.toName, time, this.onLineUserInfo.roomId,'TEXT')
      this.sendThing = '';
    },
    /*获取聊天对象信息*/
    getUserInfo() {
      let that = this;
      joinShop({
        request: 'form',
        shopId: that.id,
        userId: that.CustomInfo.cid != 0 && that.CustomInfo.cid != undefined ? that.CustomInfo.cid : 0,
        cid: that.CustomInfo.cid != 0 && that.CustomInfo.cid != undefined ? that.CustomInfo.cid : 0,
        uid: that.CustomInfo.cid != 0 && that.CustomInfo.cid != undefined ? that.CustomInfo.cid : 0,
      }).then(res => {
        if (res.code == 200) {
          that.bqwShop = res.content.bqwShop;
          that.online_id = that.bqwShop.id;
          /*初始化加载websocket*/
          websocket.Init();
          /*获取聊天房间号*/
          privateLetter({
            source: '帮企网',
            suid: that.CustomInfo.cid,
            tuid: that.bqwShop.shopUserId,
            type: 1,
            request: 'form'
          }).then(res => {
            if (res.code == 200) {
              // 定义一个方法查找对象
              function findRoomId(row) {
                return row.roomId === res.content.roomId;
              }
              if (that.chatUserInfo.find(findRoomId)) {
                for (let chat of that.chatUserInfo) {
                  if (chat.roomId == res.content.roomId) {
                    that.online_id = res.content.roomId;
                    that.onLineUserInfo = chat;
                    store.state.chatRecord = chat;
                    store.state.chatRecord.chatProject = [];
                    that.isLoading=true;
                    that.getChatLog();
                  }
                }
              } else {
                let roomId=res.content.roomId
                getCustomInfo({
                  uid:that.CustomInfo.cid,
                  cid:that.bqwShop.shopUserId
                }).then(res=>{
                  if (res.code==200){
                    store.commit('SetChatUser', {
                      roomId: roomId,
                      tavatar: res.data.useravatar,
                      toName: res.data.userID,
                      tuid: res.data.cid,
                      chatProject: []
                    })
                  }
                })

              }
            }
          })
        }
      })
    },
    /*获取聊天历史记录*/
    getChatLog() {
      let that = this;
      msgChatLog({page: that.page, pageLimit: 15, roomId: that.online_id}).then(res => {
        if (res.code == 200) {
          that.isLoading=false;
          if (res.content.rows.length > 0) {
            for (let a = 0; a < res.content.rows.length; a++) {
              if (res.content.rows[a].text.indexOf('\n') > -1) {
                res.content.rows[a].text = res.content.rows[a].text.replace(/\n/g, "<br/>")
              }
              if (a > 0) {
                if (that.dateDiff((res.content.rows[a].time - 0), (res.content.rows[a - 1].time) - 0) < 5) {
                  res.content.rows[a].ishsow = false;
                } else {
                  res.content.rows[a].ishsow = true;
                }
              } else {
                res.content.rows[a].ishsow = true;
              }
              store.commit('SET_ChatMessage', res.content.rows[a]);
            }
          }
        }else{
          that.isLoading=false;
        }
      })
    },
    /*获取离线消息房间号列表*/
    getMessagesForRoom() {
      let that = this;
      msgCurrentRoomList({
        uid: that.CustomInfo.cid != 0 && that.CustomInfo.cid != undefined ? that.CustomInfo.cid : 0
      }).then(res => {
        if (res.code == 200) {
          if (res.content.length > 0) {
            res.content.forEach(function (item) {
              let message = item;
              message.chatProject = [];
              store.commit('SetChatUser', message)
            })
          }
        }
      })
    },
    /*获取更多历史聊天记录*/
    getMoreMessage(){
      this.page++;
      this.isLoading=true;
      window.isMove=false;
      this.getChatLog();
    },
    /*图片预览*/
    seePdf(url){
      this.dialogImageUrl = url;
      this.dialogImage = true;
    },
    /*图片上传成功后处理*/
    successUpload(response, file, fileList) {
      for (let list of fileList) {
        this.sendFile(list);
      }
    },
    /*发送图片信息*/
    sendFile(list){
      let time = new Date().getTime();
      websocket.Send(5, this.onLineUserInfo.tuid.toString(), list.response.imgPath, this.onLineUserInfo.toName, time, this.onLineUserInfo.roomId,'PIC')
    },
    /*搜索用户列表*/
    searchUser(){
      let that=this;
      that.searchUserInfo=[];
      msgFriendSearch({
        "keyword": that.keyword,
        "uid": that.CustomInfo.cid != 0 && that.CustomInfo.cid != undefined ? that.CustomInfo.cid : 0,
      }).then(res=>{
        if (res.code==200){
          if (res.content.length>0){
            for (let list of that.chatUserInfo){
              for (let list2 of res.content){
                if (list.roomId===list2.roomId){
                  that.searchUserInfo.push(list);
                }
              }
            }
            that.displayNo='block'
          }
        }
      })
    }
  },
  beforeMount() {
    let that = this;
    that.CustomInfo = JSON.parse(sessionStorage.getItem('CustomInfo'));
    that.id = that.$route.query.id;
  },
  mounted() {
    window.isMove=this.isMove;
    this.getMessagesForRoom();
    this.getUserInfo();
  },
  destroyed() {
    // 销毁监听
    websocket.closeWebSocket();
  },
  updated() {
    let that=this;
    that.$nextTick(() => {
      if (window.isMove){
        setTimeout(function () {
          document.getElementById('box1').scrollTop=(document.getElementById('messageMove').clientHeight*1)+1000;
          console.log(document.getElementById('messageMove').clientHeight,document.getElementById('box1').scrollTop)
        }, 100);
     }
    })
  }
}
</script>
<style scoped>
.service-container >>> .service-header .el-menu--horizontal > .el-menu-item {
  float: left;
  height: 50px;
  line-height: 50px;
  margin: 0px 20px;
  padding: 0 10px;
  border-bottom: 2px solid transparent;
  color: #333333;
  font-size: 16px;
}

.service-container >>> .service-header .service-content .el-header {
  padding: 15px;
}

.emojiList {
  width: 520px;
  height: 300px;
  overflow: auto;
  background-color: white;
  text-align: justify;
  align-items: center;
  flex-wrap: wrap;
  z-index: 9999;
  padding: 0 10px 10px 0px;
}

.emojiList >>> span {
  font-size: 20px;
  cursor: pointer;
  width: 58px;
  margin: 10px 5px;
}

.footer-toolbar {
  padding: 10px 20px;
  display: flex;
  justify-content: left;
}

.service-container >>> .service-header .el-footer {
  padding: 10px 0px;
}

.service-container >>> .el-textarea__inner {
  border: none;
  resize: inherit;
  font-size: 14px;
  color: #333333;
}
.service-container >>> .vxe-button.type--text {
  color: #333333;
  font-size: 14px;
}
.service-container >>> .el-upload-dragger {
  background-color: #F7F7F7;
  border: 1px solid #EDEDED;
  border-radius: 0px;
  box-sizing: border-box;
  width: 100%;
  height: 100px;
  cursor: pointer;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
}
.service-container >>> .el-upload {
  width: 50px;
  border: none;
  display: flex;
  height: 22px;
  line-height: 22px;
}
.service-container >>> .el-icon-upload {
  font-size: 26px;
  color: #ABABAB;
  margin: 0px 10px 0px 0px;
  line-height: normal;
  padding-bottom: 26px;
}
.service-container >>> .el-upload__text {
  color: #ABABAB;
  line-height: 25px;
}
.service-container >>> .el-upload-list__item {
  font-size: 14px;
  color: #606266;
  width: fit-content;
}
.service-container >>> .el-upload-list--picture-card {
  display: none;
}
</style>
<style scoped lang="scss">
.service-container {
  background: #929292;

  .service-header {
    background: #929292;
    padding: 60px 18% 30px;
    min-width: 76rem;
    .service-content {
      background: #FFFFFF;

      .el-header-online-user {
        background: #F5F5F5;
        display: flex;
        align-items: center;
        justify-content: left;

        .online-user-name {
          padding-left: 15px;
          font-family: 'SourceHanSansCN';
          font-size: 18px;
          color: #333333;
        }
      }

      .el-aside-user-thing {
        background: #F5F5F5;

        .user-menu {
          background: #FE273B;
          padding: 20px;
          position: absolute;
          width: 310px;

          .user-top {
            display: flex;
            align-items: start;
            justify-content: left;
            padding-bottom: 5px;

            .online-user-name {
              padding-left: 15px;

              .user-name {
                font-family: "SourceHanSansCN";
                font-size: 18px;
                color: #FFFFFF;
                margin-block-end: 0px;
                margin-block-start: 0px;
              }

              .blurb {
                font-size: 14px;
                color: #FFFFFF;
                margin-block-end: 10px;
                margin-block-start: 0px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                word-wrap: break-word;
                word-break: break-all;
              }
            }
          }
        }
        .search-content{
          overflow-y: auto;
          position: absolute;
          background: #ffffff;
          width: inherit;
          margin-top: 133px;
          min-height: 69%;
          max-height: 69%;
          .user-list {
            padding: 10px 20px;
            display: flex;
            justify-content: left;
            align-items: center;
            .user-name {
              padding-left: 15px;
              font-size: 16px;
              color: #333333;
            }
          }
        }
        .el-user-list {
          padding-top: 140px;
          overflow-y: auto;
          height: 70vh;

          .user-list {
            padding: 10px 20px;
            display: flex;
            justify-content: left;
            align-items: center;

            .user-name {
              padding-left: 15px;
              font-size: 16px;
              color: #333333;
            }
          }

          .online-user {
            padding: 10px 20px;
            display: flex;
            justify-content: left;
            align-items: center;
            background: #FFD2D4;

            .user-name {
              padding-left: 15px;
              font-size: 16px;
              color: #333333;
            }
          }
        }
      }

      .el-main-content {
        .service-time {
          text-align: center;
          color: #999999;
          font-size: 14px;
        }

        .loading-more {
          text-align: center;
          display: flex;
          justify-content: center;
          font-size: 14px;
          color: #333333;
          font-family: 'SourceHanSansCN';
        }

        .service-content-list-left {
          display: flex;
          align-items: start;
          padding-bottom: 20px;

          .service-name {
            font-size: 14px;
            color: #666666;
            margin-block-start: 0px;
            margin-block-end: 10px;
          }

          .service-info {
            font-size: 14px;
            color: #333333;
            padding: 10px 15px;
            background: #F5F5F5;
            border-radius: 0px 12px 12px 12px;
            margin-block-start: 0px;
            margin-block-end: 0px;
            max-width: 35vw;
            text-align: left;
            line-height: 26px;
          }
          .service-image{
            border-radius: 0px 12px 12px 12px;
            width: 300px;
            text-align: left;
            line-height: 26px;
          }
        }

        .service-content-list-right {
          display: flex;
          align-items: start;
          padding-bottom: 20px;
          justify-content: right;

          .service-name {
            font-size: 14px;
            color: #666666;
            margin-block-start: 0px;
            margin-block-end: 10px;
          }

          .service-info {
            font-size: 14px;
            color: #FFFFFF;
            padding: 10px 15px;
            background: #FE273B;
            border-radius: 12px 0px 12px 12px;
            margin-block-start: 0px;
            margin-block-end: 0px;
            max-width: 35vw;
            text-align: left;
            line-height: 26px;
            width: fit-content;
            display: -webkit-inline-box;
          }
          .service-image{
            border-radius: 12px 0px 12px 12px;
            width: 300px;
            text-align: right;
            line-height: 26px;
          }
        }

      }

      .el-send {
        float: right;
        margin-top: 140px;
        z-index: 100007;
        position: absolute;
        margin-left: -80px;
      }
    }
  }
}

//滚动条的宽度
::-webkit-scrollbar {
  width: 8px !important;
  height: 50px !important;
}

//滚动条的滑块
::-webkit-scrollbar-thumb {
  height: 8px !important;
  border-radius: 8px !important;
  background-color: #DDDDDD !important;
}
</style>